import React, { useState } from "react";
import Layout from "../../layout/Layout";
import { MdEdit } from "react-icons/md";
import img from "../../assets/images/1593886786277.jpg";
import { uploadFile } from "../../services/auth";
import { baseUrl } from "../../services/api";

function ProfileSetting() {
  // State variables to manage editable fields
  const [fullName, setFullName] = useState("Admin");
  const [fatherName, setFatherName] = useState("Admin");
  const [email, setEmail] = useState("admin@gmail.com");
  const [phoneNumber, setPhoneNumber] = useState("+92-234-000-0000");
  const [cnic, setCnic] = useState("000-234-000-0000");
  const [country, setCountry] = useState("Pakistan");
  const [cityState, setCityState] = useState("Sindh, Karachi");
  const [presentAddress, setPresentAddress] = useState(
    "Lorem Ipsum Street 435"
  );
  const [postalCode, setPostalCode] = useState("23400");

  // State variables to toggle edit mode
  const [isEditingPersonalInfo, setIsEditingPersonalInfo] = useState(false);
  const [isEditingAddress, setIsEditingAddress] = useState(false);

  // State variable for profile image
  const [profileImage, setProfileImage] = useState(img);

  const handleSave = () => {
    setIsEditingPersonalInfo(false);
    setIsEditingAddress(false);
  };

  const uploadPicker = async (e) => {
    try {
      const file = e.target.files[0];
      console.log("Selected file:", file);

      const formData = new FormData();
      formData.append("file", file);

      const { status, data } = await uploadFile(formData);
      console.log("Upload status:", status);
      console.log("Response data:", data);

      if (status === 200 || status === 201) {
        const imageUrl = `${baseUrl}${data.data.url}`;
        console.log("Constructed image URL:", imageUrl, data.data.url);
        setProfileImage(imageUrl);
      } else {
        throw new Error(`Unexpected response status: ${status}`);
      }
    } catch (error) {
      console.error("File upload failed:", error);
    }
  };

  return (
    <>
      <Layout>
        {/* Heading */}
        <div className="row text-center">
          <h3 className="h3">YOUR PROFILE</h3>
        </div>

        <div className="row flex flex-wrap pr-3">
          {/* LeftSide Profile */}
          <div className="col-lg-3 col-md-3 col-sm-12 text-center py-3">
            <h6 className="h6 pb-2">MY PROFILE</h6>
            <div>
              <img
                className="mb-3"
                src={profileImage}
                alt=""
                style={{
                  width: 150,
                  borderRadius: "50%",
                  border: "5px solid white",
                  boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                  aspectRatio: 1 / 1,
                  objectFit: "cover",
                }}
              />
            </div>
            <div className="py-2">
              <label
                className="btn btn_contained_black text-white fs_12 btn-sm"
                style={{ padding: "5px 12px" }}
              >
                Change Profile
                <input
                  style={{ display: "none" }}
                  type="file"
                  onChange={uploadPicker}
                />{" "}
              </label>
            </div>
            <div className="mt-1">
              <button className="btn btn-outline-danger fs_12 btn-sm px-3">
                Delete Picture
              </button>
            </div>
          </div>

          {/* RightSide Profile */}
          <div className="col-lg-9 col-md-9 col-sm-12 p-3">
            {/* FirstCard */}
            <div className="row border rounded p-3">
              <div className="d-flex justify-content-between">
                <h5 className="h5">Personal Information</h5>
                {!isEditingPersonalInfo && (
                  <button
                    className="btn btn_contained_black fs_12 btn-sm text-white px-3"
                    onClick={() => setIsEditingPersonalInfo(true)}
                  >
                    <MdEdit className="me-2" style={{ marginBottom: "2px" }} />
                    Edit
                  </button>
                )}
              </div>

              <div className="row py-2">
                <div className="col-6">
                  <div className="text-secondary fs_14 pb-1">Full Name</div>
                  {isEditingPersonalInfo ? (
                    <input
                      type="text"
                      className="form-control fs_16"
                      value={fullName}
                      onChange={(e) => setFullName(e.target.value)}
                    />
                  ) : (
                    <div className="fs_16">{fullName}</div>
                  )}
                </div>
                <div className="col-6">
                  <div className="text-secondary fs_14 pb-1">Father Name</div>
                  {isEditingPersonalInfo ? (
                    <input
                      type="text"
                      className="form-control fs_16"
                      value={fatherName}
                      onChange={(e) => setFatherName(e.target.value)}
                    />
                  ) : (
                    <div className="fs_16">{fatherName}</div>
                  )}
                </div>
              </div>

              <div className="row py-2 d-flex flex-wrap">
                <div className="col-lg-6 col-md-6 col-sm-12 py-2">
                  <div className="text-secondary fs_14 pb-1">Email Address</div>
                  {isEditingPersonalInfo ? (
                    <input
                      type="text"
                      className="form-control fs_16"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  ) : (
                    <div className="fs_16">{email}</div>
                  )}
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 py-2">
                  <div className="text-secondary fs_14 pb-1">Phone Number</div>
                  {isEditingPersonalInfo ? (
                    <input
                      type="text"
                      className="form-control fs_16"
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                    />
                  ) : (
                    <div className="fs_16">{phoneNumber}</div>
                  )}
                </div>
              </div>

              <div className="row py-2">
                <div className="text-secondary fs_14 pb-1">
                  NIC/Passport/Licence/Ration Card Number
                </div>
                {isEditingPersonalInfo ? (
                  <input
                    type="text"
                    className="form-control fs_16"
                    value={cnic}
                    onChange={(e) => setCnic(e.target.value)}
                  />
                ) : (
                  <div className="fs_16">{cnic}</div>
                )}
              </div>
            </div>

            <br></br>
            {/* SecondCard */}
            <div className="row border rounded p-3">
              <div className="d-flex justify-content-between">
                <h5 className="h5">Address</h5>
                {!isEditingAddress && (
                  <button
                    className="btn btn_contained_black fs_12 btn-sm text-white px-3"
                    onClick={() => setIsEditingAddress(true)}
                  >
                    <MdEdit className="me-2" style={{ marginBottom: "2px" }} />
                    Edit
                  </button>
                )}
              </div>

              <div className="row py-2">
                <div className="col-6">
                  <div className="text-secondary fs_14 pb-1">Country</div>
                  {isEditingAddress ? (
                    <input
                      type="text"
                      className="form-control fs_16"
                      value={country}
                      onChange={(e) => setCountry(e.target.value)}
                    />
                  ) : (
                    <div className="fs_16">{country}</div>
                  )}
                </div>
                <div className="col-6">
                  <div className="text-secondary fs_14 pb-1">City/State</div>
                  {isEditingAddress ? (
                    <input
                      type="text"
                      className="form-control fs_16"
                      value={cityState}
                      onChange={(e) => setCityState(e.target.value)}
                    />
                  ) : (
                    <div className="fs_16">{cityState}</div>
                  )}
                </div>
              </div>

              <div className="row py-2">
                <div className="col-lg-6 col-md-6 col-sm-12 py-2">
                  <div className="text-secondary fs_14 pb-1">
                    Present Address
                  </div>
                  {isEditingAddress ? (
                    <input
                      type="text"
                      className="form-control fs_16"
                      value={presentAddress}
                      onChange={(e) => setPresentAddress(e.target.value)}
                    />
                  ) : (
                    <div className="fs_16">{presentAddress}</div>
                  )}
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 py-2">
                  <div className="text-secondary fs_14 pb-1">Postal Code</div>
                  {isEditingAddress ? (
                    <input
                      type="text"
                      className="form-control fs_16"
                      value={postalCode}
                      onChange={(e) => setPostalCode(e.target.value)}
                    />
                  ) : (
                    <div className="fs_16">{postalCode}</div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 text-right p-1">
            <button
              className="btn btn_contained_black fs_12 btn-sm text-white px-3"
              onClick={handleSave}
            >
              Save
            </button>
          </div>
        </div>
      </Layout>
    </>
  );
}

export default ProfileSetting;
